import { render, staticRenderFns } from "./Question_simple.vue?vue&type=template&id=16c8a94d"
import script from "./Question_simple.vue?vue&type=script&lang=js"
export * from "./Question_simple.vue?vue&type=script&lang=js"
import style0 from "./Question_simple.vue?vue&type=style&index=0&id=16c8a94d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.90.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports